module.exports = __webpack_public_path__ + "c4719353ff.png";